import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';

export interface ScheduledTeamOrdersProps {
  name: string;
  id: string;
}

export function ScheduledTeamOrders({
  name,
  id,
}: ScheduledTeamOrdersProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      label="Scheduled Team Orders"
    />
  );
}
